export const setAutocarHeaderVisibility = (visible: boolean) => {
  const autocarHeader = document.querySelector('#mini-panel-sitewide_header');
  if (autocarHeader && autocarHeader.style) {
    autocarHeader.style.display = visible ? 'revert' : 'none';
  }
};



// WEBPACK FOOTER //
// ./src/utils/autocar/index.js